/*global Q */
var $ = require('jquery');
var websiteData = require('diy/util/websiteData');
var popupWindow = require('diy/util/popupWindow');

var
    DEFAULT_POPUP_OPTIONS = {
        'menubar': 'no',
        'location': 'yes',
        'resizable': 'yes',
        'scrollbars': 'yes',
        'status': 'yes',
        'width': 700,
        'height':300,
        'top': undefined,
        'left': undefined
    },
    DEFAULT_POPUP_NAME = "share",
    ShareButton
    ;

/**
 * @class diy.social.ShareButton
 * @template diy.social.ShareButton
 * @lends {diy.social.ShareButton.prototype}
 * @constructor
 */
ShareButton = Klazz.extend({
    /**
     * @type {{
     *      url: String,
     *      image: String| undefined,
     *      onClick: Function | undefined,
     *      onSubmit: Function | undefined,
     *      message: {
     *          text: String | undefined,
     *          hashTags: String | undefined
     *      } | undefined,
     *      actions : [{
     *          name: String,
     *          link: String
     *      }] | undefined,
     *      appId: String | undefined
     * }}
     */
    options: undefined,

    /**
     * @type jQuery
     */
    $parentElement: undefined,

    /**
     * @type jQuery
     */
    $element: undefined,

    /**
     * @type String (ex: 'en')
     */
    language: null,

    /**
     * @type String (ex: 'en_CA')
     */
    locale: null,

    /**
     * @type String (ex: 'us' | 'ca' | 'mx')
     */
    market: '',

    initialize: function ($parentElement, options) {
        this.setLocales();
        this.$parentElement = $parentElement;
        this.setOptions(options);
    },

    /**
     * @private
     */
    setLocales: function () {
        this.locale = websiteData.getLanguageCode();
        this.language = websiteData.getLanguage();
        this.market = websiteData.getMarket();
    },
    /**
     *
     * @param options {*}
     * @returns {diy.social.ShareButton}
     */
    setOptions: function (options) {
        var defaults = {
            onClick: undefined,
            onSubmit: undefined,
            image: undefined,
            message: {
                url: undefined,
                text: undefined
            }
        };

        this.options = $.extend(true, {}, defaults, options);
        return this;
    },
    /**
     * @private
     */
    createPlaceHolder: function () {
        this.$element = $('<div class="diy-share-button"></div>').appendTo(this.$parentElement);
    },
    /**
     *
     * @returns {Promise|Q.promise}
     */
    render: function () {
        return Q(this.createPlaceHolder())
            .then(this.loadApi.bind(this))
            .then(this.createButton.bind(this));
    },
    /**
     *
     * @param callback {Function|undefined}
     * @param data {=Object}
     */
    executeCallback: function (callback, data) {
        if (typeof callback === 'function') {
            callback.call(this, data);
        }
    },
    onClick: function() {
        this.executeCallback(this.options.onClick);
    },
    /**
     *
     * @param data {=Object}
     */
    onSubmit: function(data) {
        this.executeCallback(this.options.onSubmit, data);
    },
    /**
     *
     * @param url {String}
     * @param options {=String}
     */
    openWindow: function(url, options) {
        var windowOptions;

        windowOptions = $.extend(true, {}, DEFAULT_POPUP_OPTIONS, options);
        $.extend(windowOptions, popupWindow.getTopLeftForCenterWindow(windowOptions.width, windowOptions.height));

        return popupWindow.newWindow(url, DEFAULT_POPUP_NAME, windowOptions);
    },
    /**
     *
     * @returns {Promise|Q.promise}
     */
    loadApi: function () {
        return Q(true);
    },
    /**
     * @returns {Promise|Q.promise|*}
     */
    createButton: function () {
        throw new Error('Function must be implemented.');
    }
});

module.exports = ShareButton;



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/social/ShareButton.js
 ** module id = 736
 ** module chunks = 0
 **/